import * as i0 from '@angular/core';
import { LOCALE_ID, Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import * as i1 from '@angular/platform-browser';
import * as i2 from '@arematics/core/api';
import { TitleStrategy } from '@angular/router';

class SeoService {
    title;
    meta;
    utils;
    document;
    localeId;
    otherLang;
    localeNames = {
        de: 'Deutschland',
        'en-US': 'United States'
    };
    currentLocaleName;
    constructor(title, meta, utils, document, localeId) {
        this.title = title;
        this.meta = meta;
        this.utils = utils;
        this.document = document;
        this.localeId = localeId;
        this.otherLang = this.localeId === 'en-US' ? 'de' : 'en-US';
        this.currentLocaleName = this.getLocaleName(this.localeId);
    }
    getLocaleName(localeId) {
        return this.localeNames[localeId] || localeId;
    }
    update(property, content) {
        this.meta.updateTag({ property, content });
    }
    updateTitle(title) {
        const localeAppend = this.localeId === 'en-US' ? '' : ` (${this.currentLocaleName})`;
        title = (title ? title + ' - ' : '') + `Arematics${localeAppend}`;
        this.title.setTitle(title);
        this.meta.updateTag({ property: 'og:title', content: title });
    }
    updateDescription(desc) {
        this.meta.updateTag({ name: 'description', content: desc });
        this.meta.updateTag({ property: 'og:description', content: desc });
    }
    updateKeywords(desc) {
        this.meta.updateTag({ name: 'keywords', content: desc });
    }
    enableCanonical() {
        const routerAbsoluteUrl = this.document.location.href;
        const routerAbsoluteUrlOther = this.utils.replaceLanguagePart(routerAbsoluteUrl, this.localeId, this.otherLang);
        const head = this.document.head;
        var element = this.document.querySelector(`link[rel='canonical']`) || null;
        if (element == null) {
            element = this.document.createElement('link');
            head.appendChild(element);
        }
        element.setAttribute('rel', 'canonical');
        element.setAttribute('href', routerAbsoluteUrl);
        var element2 = this.document.querySelector(`link[rel='alternate']`) || null;
        if (element2 == null) {
            element2 = this.document.createElement('link');
            head.appendChild(element2);
        }
        element2.setAttribute('rel', 'alternate');
        element2.setAttribute('href', routerAbsoluteUrlOther);
        element2.setAttribute('hreflang', this.otherLang);
        this.meta.updateTag({ property: 'og:url', content: routerAbsoluteUrl });
    }
    addKeywords(words) {
        const keywords = this.meta.getTag('name= "keywords"');
        if (keywords !== null) {
            words.forEach((word) => (keywords.content = keywords.content + ', ' + word));
            this.updateKeywords(keywords.content);
        }
    }
    removeKeywords(words) {
        const keywords = this.meta.getTag('name= "keywords"');
        if (keywords !== null) {
            const filtered = keywords.content
                .split(',')
                .join('')
                .split(' ')
                .filter((word) => words.indexOf(word) === -1);
            this.updateKeywords(filtered.join(', '));
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SeoService, deps: [{ token: i1.Title }, { token: i1.Meta }, { token: i2.UtilsService }, { token: DOCUMENT }, { token: LOCALE_ID }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SeoService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SeoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.Title }, { type: i1.Meta }, { type: i2.UtilsService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }]; } });

const titleStrategyFactory = (title, seo) => new ArematicsTitleStrategy(title, seo);
class ArematicsTitleStrategy extends TitleStrategy {
    title;
    seo;
    constructor(title, seo) {
        super();
        this.title = title;
        this.seo = seo;
    }
    updateTitle(snapshot) {
        const title = this.buildTitle(snapshot);
        if (title !== undefined) {
            this.seo.updateTitle(title);
        }
        else {
            this.seo.updateTitle();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ArematicsTitleStrategy, deps: [{ token: i1.Title }, { token: SeoService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ArematicsTitleStrategy });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ArematicsTitleStrategy, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.Title }, { type: SeoService }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { ArematicsTitleStrategy, SeoService, titleStrategyFactory };
